export type ModifierKey = "ward" | "stealth" | "lance" | "disabled" | "engulfed" | "burned" | "flooded";

export type ModifierDef = {
  key: ModifierKey;          // stored on the card
  name: string;              // shown in UI
  allowed: Array<"minion" | "site">;
  icon: string;              // image slug in /card-images_tokens/
  colorON: string;
};

export const MODIFIER_TOKENS: ModifierDef[] = [
  { key: "ward",        name: "Ward",       allowed: ["minion", "site"],   icon: "ward",       colorON: "rgba(103, 193, 221, 0.94)"},
  { key: "stealth",     name: "Stealth",    allowed: ["minion"],           icon: "stealth",    colorON: "rgba(32, 109, 95, 1)"},
  { key: "lance",       name: "Lance",      allowed: ["minion"],           icon: "lance",      colorON: "rgba(72, 53, 31, 0.99)"},
  { key: "disabled",    name: "Disabled",   allowed: ["minion"],           icon: "disabled",   colorON: "#72915fff"},
  { key: "engulfed",    name: "Engulfed",   allowed: ["minion"],           icon: "engulfed",   colorON: "#81762cff"},
  { key: "burned",      name: "Burned",     allowed: ["site"],             icon: "burned",     colorON: "#ff6d10ff"},
  { key: "flooded",     name: "Flooded",    allowed: ["site"],             icon: "flooded",    colorON: "#2669d5ff"},
];